var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 13,
  viewBox: "0 0 8 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 4a4 4 0 1 1 7.844 1.11c.1-.069-3.344 7.39-3.344 7.39h-1S.055 5.041.156 5.11A4 4 0 0 1 0 4m5.5 0v-.023Q5.488 2.5 4 2.5 2.5 2.5 2.5 4T4 5.5 5.5 4"
})));
export default SvgLocationMarker;